import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { Grid } from "../core/components/grid.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Helper } from "../core/util/helper.js";
import { createHtppServiceInstance, HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { SmartSearchAutoComplete } from "./smartSearchAutoComplete.js";
import { SmartSearchHelper, SmartSearchSearchResultPreview, PdfPreview, SmartSearchPdfPreviewInternal } from "./smartSearchSearchResult.js";
import { GridCustomToolBarButton, ToolBar } from "../core/components/toolBar.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { CancelTokenSource } from "axios";
import { Context, Entity } from "../core/components/commonApp.js";
import { Menu } from "../core/components/menu.js";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

export let startContextLess = () => {
    const props: SmartSearchListProps = {
        favoriteIds: () => [],
        id: "",
        initialMachine: null,
        initialValue: null,
        readOnly: true,
        removeFavorite: async () => {
            return false;
        },
        addFavorite: async () => {
            return false;
        },
        onFavoriteClick: async () => {
            return false;
        },
    };

    General.Content.MountComponent(SmartSearchList, props);
}

interface SmartSearchAppBridgeProps {
    entity: Entity;
    handleEval: (action) => string;
    initialValue: string;
    initialMachine: string;
    id: string;
    documentType: number;
    context: Context;
}

export default class SmartSearchAppBridge extends React.Component<SmartSearchAppBridgeProps, any> {

    render() {
        const machine = this.props.handleEval(this.props.initialMachine);
        const initalValue = this.props.handleEval(this.props.initialValue);
        const id = this.props.handleEval(this.props.id);
        const canWrite = this.props.entity.RecordRight.CanWrite;
        return <SmartSearch
            canWrite={canWrite}
            canAddFavourites={!Helper.isNullOrEmpty(id)}
            canRemoveFavourites={!Helper.isNullOrEmpty(id)}
            initialValue={initalValue}
            initialMachine={machine}
            id={id}
            documentType={this.props.documentType}
            context={this.props.context}
        />
    }
}

interface SmartSearchTabProps {
    canAddFavourites: boolean,
    canRemoveFavourites: boolean,
    id: string,
    initialMachine: string,
    initialValue: string,
    documentType: number;
    context: Context;
    canWrite: boolean;
}

interface SmartSearchState {
    machineType: string,
    favourites?: SmartSearchFavorite[],
    initialized: boolean,
    searchText?: string,
    smartsearchConfig?: any,
    searchResult?: ApiSearchResult,
    selectedItems: SmartSearchFavorite[];
    documentEnabled: boolean;

}

class SmartSearch extends React.Component<SmartSearchTabProps, SmartSearchState> {

    private ADD_BUTTON_ID = "Add";
    private REMOVE_BUTTON_ID = "Remove";
    private READ_ONLY_SEARCH_BUTTON_ID = "OpenReadOnlySearch";
    private ADD_TO_DOCUMENTS_BUTTON_ID = "AddToDoc";
    private gridOptions: kendo.ui.GridOptions;
    private sheet: Sheet;

    constructor(props: SmartSearchTabProps) {
        super(props)

        this.state = {
            initialized: false,
            machineType: null,
            favourites: [],
            searchResult: null,
            searchText: null,
            smartsearchConfig: null,
            selectedItems: [],
            documentEnabled: false
        }
        this.initApp();
    }

    private initApp = () => {
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: "multiple, row",
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Mime",
                    title: Helper.getTranslation("Standard.Typ"),
                    template: (row: SmartSearchFavorite) => {
                        const type = SmartSearchHelper.getType(row.Mime);
                        const icon = SmartSearchHelper.getIcon(type);
                        return `<div style="display:flex;justify-content: center"><i class="fal fa-${icon} fa-fw fa-2x" aria-hidden="true"></i></div>`;

                    }
                },
                {
                    field: "Title",
                    title: Helper.getTranslation("WebSMS.Report.Question.Titles"),
                    template: (row: SmartSearchFavorite) => {
                        const linkClass = (Config.settings.isMobileApp && SmartSearchHelper.getType(row.Mime) === "einsatz") ? "no-click" : "";
                        return `<a data-id=${row.Id} class=${linkClass}>${row.Title}</a>`;

                    }
                },
                {
                    field: "Description",
                    title: Helper.getTranslation("Standard.Beschreibung")
                },
                {
                    field: "mobileTemplate",
                    template: (row: any) => {
                        const type = SmartSearchHelper.getType(row.Mime);
                        const icon = SmartSearchHelper.getIcon(type);
                        const linkClass = (Config.settings.isMobileApp && SmartSearchHelper.getType(row.Mime) === "einsatz") ? "no-click" : "";
                        return `<div class='list-item list-item--grid list-item--grid-icon'>
                                    <div style="display:flex;justify-content: center"><i class="fal fa-${icon} fa-fw fa-2x" aria-hidden="true"></i></div>
                                    <div>
                                        <a data-id=${row.Id} class=${linkClass}>${row.Title}</a>
                                        <div class='list-item__text list-item__text--weak'>${row.Description}</div>
                                    </div>
                                </div>`;

                    }
                }
            ]
        };
    }

    componentDidMount() {
        this.reloadFavourites();
    }

    private reloadFavourites = async () => {
        const result = await createHtppServiceInstance()
            .noBusyIndicator()
            .get<JsonResultClass<SmartSearchFavorite[]>>("SmartSearch/GetFavourites", { IsGuid: this.props.id });

        let documentEnabled = false;
        if (Helper.hasValue(result.AdditionalData) && result.AdditionalData.DocumentEnabled)
            documentEnabled = result.AdditionalData.DocumentEnabled;
        if (!this.state.initialized && documentEnabled) {
            this.gridOptions.columns.push({
                field: "AddedDocSytem",
                title: Helper.getTranslation("SmartSearch.InDocSystem"),
                template: (row: SmartSearchFavorite) => {
                    let icon = "question";
                    switch (row.DocumentStatus) {
                        case 0:
                            icon = "minus-circle";
                            break;
                        case 1:
                            icon = "check";
                            break;
                        case 2:
                            icon = "check-double";;
                            break;
                    }
                    return `<div style="display:flex;justify-content: center;"><i class='fal fa-${icon} fa-fw fa-2x' aria-hidden='true'></i></div>`;
                }
            });
        }

        this.setState({ favourites: result.Data ?? [], initialized: true, documentEnabled: documentEnabled });
    }

    private onButtonClick = async (id: string, dataItems: SmartSearchFavorite[]) => {
        const labels = dataItems.filter(fav => Helper.hasValue(fav)).map(fav => fav.Label);
        switch (id) {
            case this.ADD_BUTTON_ID:
                this.openSearch();
                break;
            case this.REMOVE_BUTTON_ID:
                const isOk = await this.removeFavorite(labels);
                if (isOk) {
                    const favourites = this.state.favourites.filter(fav => labels.indexOf(fav.Label) == -1);
                    this.setState({ favourites: favourites, selectedItems: [] })
                }
                break;
            case this.READ_ONLY_SEARCH_BUTTON_ID:
                this.openSearch(true);
                break;
            case this.ADD_TO_DOCUMENTS_BUTTON_ID:
                this.addToDocuments(labels);
                break;
        }
    }

    private openFavorite = (dataItem: SmartSearchFavorite) => {
        const type = SmartSearchHelper.getType(dataItem.Mime);
        const isguid = SmartSearchHelper.getIsGuid(dataItem.Label);
        switch (type) {
            case "ticket":
                General.Sheet.Manager.createSheetWithUrl(`Procedure/EditByGuid?isguid=${isguid}`);
                break;
            case "einsatz":
                General.Sheet.Manager.createSheetWithUrl(`ResourcePlanning/EditByGuid?isguid=${isguid}`);
                break;
            case "pdf":
                const sheet = General.Sheet.Manager.createSheet();
                sheet.show(() => {
                    if (dataItem.Bookmark) {
                        const bookmark: Bookmark = JSON.parse(dataItem.Bookmark);
                        sheet.mountContent(SmartSearchPdfPreviewInternal, { bookmark: bookmark, pageWidth: 800 } as any);
                    }
                    else {
                        sheet.mountContent(PdfPreview, { resource: dataItem.Resource });
                    }

                });
                break;
        }
    }

    private addToDocuments = async (labels: string[]) => {
        const getUrl = window.location;
        const baseUrl = getUrl.protocol + "//" + getUrl.host + Config.baseUrl;
        const result = await createHtppServiceInstance()
            .post<JsonResultClass>("SmartSearch/AddToDocuments", {
                EntityId: this.props.id,
                Labels: labels,
                Type: this.props.documentType,
                BaseUrl: baseUrl
            });

        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            await this.reloadFavourites();
            this.sheet.trigger(SheetEventType.Custom, { command: "updateDocuments" });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private openSearch = (readOnly: boolean = false) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            const props: SmartSearchListProps = {
                id: this.props.id,
                favoriteIds: () => this.state.favourites.map(f => f.Label),
                removeFavorite: this.removeFavorite,
                addFavorite: this.addFavorite,
                onFavoriteClick: this.onFavoriteClick,
                initialMachine: this.props.initialMachine,
                readOnly: readOnly,
                initialValue: this.props.initialValue
            };

            sheet.mountContent(SmartSearchList, props);
            sheet.setTitle(Helper.getTranslation("SmartSearch.SmartSearch"));
        });
        sheet.bind(SheetEventType.Close, () => {
            this.reloadFavourites();
        });
    }

    private onFavoriteClick = async (b: Bookmark): Promise<boolean> => {
        const is_favorite = Helper.hasValue(this.state.favourites.find(f => f.Label === b.id));
        if (is_favorite) {
            const is_ok = await this.removeFavorite([b.id]);
            if (is_ok) {
                const favorites = this.state.favourites.filter(f => f.Label !== b.id);
                this.setState({ favourites: favorites })
                return true;
            }
        } else {
            const is_ok = await this.addFavorite(b);
            if (is_ok) {
                const favorites = this.state.favourites
                const newDummyFavorite: any = ({ Label: b.id });
                favorites.push(newDummyFavorite);
                this.setState({ favourites: favorites })
                return true;
            }
        }
        return false;
    }
    private removeFavorite = async (labels: string[]) => {
        const is_ok = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (is_ok) {
            const result = await createHtppServiceInstance()
                .noBusyIndicator()
                .post<JsonResultClass>("SmartSearch/RemoveFavourites", {
                    ISGuid: this.props.id,
                    Labels: labels
                });
            return result.Code == 0;
        }
        return false;
    }

    private addFavorite = async (b: Bookmark) => {
        const description = await DialogHelper.prompt(Helper.getTranslation("Standard.Beschreibung"), null, null, null, true);
        if (description) {
            const pdfData: PdfData = await HTTPService.noBusyIndicator().get<any>("SmartSearchPreview/Bookmark", { id: b.id });
            const result = await createHtppServiceInstance()
                .noBusyIndicator()
                .post<JsonResultClass>("SmartSearch/AddFavouriteToTicket", {
                    IsGuid: this.props.id,
                    Label: b.id,
                    Language: b.language,
                    Mime: b.mimeType,
                    Title: b.title,
                    Description: description,
                    Resource: pdfData.resource,
                    Path: b.path,
                    Bookmark: JSON.stringify(b)
                });
            return result.Code == 0;
        }
        return false
    }

    private getButtons = () => {
        const customButtons: GridCustomToolBarButton[] = [];
        const selectedItems = this.state.selectedItems.filter(item => Helper.hasValue(item));
        if (this.props.canWrite && this.props.canAddFavourites) {
            customButtons.push({ id: this.ADD_BUTTON_ID, caption: Helper.getTranslation("SmartSearch.AddFavorite"), autoEnabledOnRecordSelected: false, iconClass: "k-i-plus", enabled: true });
        } else {
            customButtons.push({ id: this.READ_ONLY_SEARCH_BUTTON_ID, caption: Helper.getTranslation("SmartSearch.OpenSearch"), autoEnabledOnRecordSelected: false, iconClass: "k-i-search", enabled: true });
        }
        if (this.props.canWrite && this.props.canRemoveFavourites) {
            customButtons.push({
                id: this.REMOVE_BUTTON_ID,
                caption: Helper.getTranslation("SmartSearch.RemoveFavorite"),
                autoEnabledOnRecordSelected: true,
                iconClass: "k-i-minus",
                enabled: (this.state.favourites.length > 0 && selectedItems.length > 0),
                useContextMenu: true
            });
        }

        if (this.props.canWrite && this.state.documentEnabled && Helper.hasValue(this.props.documentType)) {
            customButtons.push({
                id: this.ADD_TO_DOCUMENTS_BUTTON_ID,
                caption: Helper.getTranslation("SmartSearch.AddAsDocument"),
                autoEnabledOnRecordSelected: true,
                iconClass: "fal fa-file-alt fa-fw",
                enabled: (this.state.favourites.length > 0 && (selectedItems.filter(fav => fav.DocumentStatus < 2).length > 0)),
                useContextMenu: true
            });
        }

        return customButtons;
    }

    private renderGrid = () => {
        return (
            <>
                <Grid
                    id="smartSearch_favourites"
                    data={this.state.favourites}
                    options={this.gridOptions}
                    onSelectionChanged={(dataItem) => {
                        if (Array.isArray(dataItem)) {
                            this.setState({ selectedItems: dataItem })
                        } else {
                            this.setState({ selectedItems: [dataItem] })
                        }
                    }}
                    onDataBound={this.onDataBound}
                    customButtons={this.getButtons()}
                    onClickCustomButton={(id) => this.onButtonClick(id, this.state.selectedItems)}
                    gridDetails={{ useFeature: true }}
                    useFloatingButtons={true}
                    noRecords={this.getReplacementText()}
                >
                </Grid>
            </>
        );
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const link = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] a`);
            const id = link.attr("data-id");

            if (!Helper.isNullOrEmpty(id)) {
                link.click(() => {
                    const fav = this.state.favourites.find(f => f.Id == id);
                    if (Helper.hasValue(fav)) {
                        this.openFavorite(fav)
                    }
                });
            }
        }
    }

    private getReplacementText = () => {
        return (`
            <div style='display: flex; flex-direction: column; opacity: 0.2; align-items: center; padding-left: 5px; justify-content: center; flex: 1;'>
                <div style='display: flex; justify-content: center;'>
                    <span class="fa-stack fa-8x">
                        <i class="fal fa-star fa-stack-1x"></i>
                        <i class="fal fa-ban fa-stack-2x"></i>
                    </span>
                </div>
                <div style='text-align: center;'>
                    <label style='font-size: 35px;'>
                        ${Helper.getTranslation("SmartSearch.NoFavorites")}
                    </label>
                </div>
            </div>
        `);
    }

    render() {
        if (!this.state.initialized)
            return <></>;

        return (
            <div className="flex-container">
                {this.renderGrid()}
            </div>
        );
    }
}

interface SmartSearchFavorite {
    Label: string;
    Mime: string;
    DokuId: number;
    Resource: string;
    DocumentStatus: 0 | 1 | 2;
    Title: string;
    Id: string;
    Bookmark: string;
}

export class SmartSearchList extends React.Component<SmartSearchListProps, SmartSearchListState> {
    private autoComplete: SmartSearchAutoComplete;
    private OK_STATUS = 200;
    private lastCancelToken: CancelTokenSource;
    private leftDrawerRef: JQuery<HTMLElement>;
    private sheet: Sheet;
    constructor(props: SmartSearchListProps) {
        super(props);
        this.state = {
            machineType: null,
            initialized: false,
            smartsearchConfig: {},
            favoriteIds: props.favoriteIds,
            searching: false,
            currentPage: 0
        };
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.leftDrawerRef = this.sheet.elements.getLeftDrawerElementRef();
        this.initApp();
    }

    private initApp = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Close, this.cancelRequest);
    }

    private cancelRequest = () => {
        if (Helper.hasValue(this.lastCancelToken)) {
            this.lastCancelToken.cancel();
            this.lastCancelToken = null;
        }
    }

    private initSearch = async () => {
        try {
            const initResult = await createHtppServiceInstance().noBusyIndicator().post<SmartSearchApiInitResult>("SmartSearchPreview/init", {
                Machine: this.props.initialMachine,
            });
            return initResult
        } catch (e) {
            NotificationHelper.showErrorMessage(e.message);
            return null;
        }
    }

    async componentDidMount() {
        const searchResult = await this.initSearch();
        const initialValues: SmartSearchAPiCompletitionResult[] = [];

        if (Helper.hasValue(searchResult.MachineType)) {
            initialValues.push({ ConceptURI: searchResult.MachineType.ConceptURI, Type: searchResult.MachineType.Type, Text: searchResult.MachineType.Text, ConceptName: searchResult.MachineType.ConceptName });
        }

        if (Helper.hasValue(this.props.initialValue)) {
            initialValues.push({ ConceptURI: this.props.initialValue, Type: "Text", Text: this.props.initialValue });
        }

        if (Helper.hasValue(this.props.initialConcepts)) {
            for (var concept of this.props.initialConcepts) {
                initialValues.push({ ConceptURI: concept.ConceptURI, Type: concept.Type ?? "", Text: concept.Text });
            }

        }

        this.setState({ initialized: true, initResult: initialValues, searching: true }, () => {
            if (initialValues && initialValues.length > 0) {
                this.executeSearch(initialValues, initialValues, 0);
            }
        });
    }

    private handleSelectionChanged = () => {
        const values = this.autoComplete.getSelected();
        if (values.length == 0) {
            this.cancelRequest();
            this.setState({
                searchResult: {
                    bookmarks: [],
                    query: {
                        concept: []
                    }
                }, searching: false
            });
        } else {
            this.setState({ searching: true }, () => {
                this.executeSearch(values, values, 0);
            })
        }
    }

    private executeSearch = async (concepts: SmartSearchAPiCompletitionResult[], phrases: SmartSearchAPiCompletitionResult[], page: number, preserveBookmarks: any = null) => {
        this.cancelRequest();

        const conceptsUris = concepts
            .filter(x => x.Type != "Text" && !Helper.isNullOrEmpty(x.ConceptURI))
            .map(x => x.ConceptURI);

        const phrasesUris = phrases
            .filter(x => x.Type == "Text" && !Helper.isNullOrEmpty(x.ConceptURI))
            .map(x => x.ConceptURI);

        const queryObject = { conceptURIs: conceptsUris, phrases: phrasesUris, limit: 25, page: page };


        const currentToken = axios.CancelToken.source();
        this.lastCancelToken = currentToken;

        try {
            Helper.setBusyIndicator(true).then(async _ => {
                const result = await axios.post<ApiSearchResult>(Config.baseUrl + "SmartSearchPreview/Start", queryObject, {
                    cancelToken: currentToken.token
                });

                if (typeof result.data == "string") {
                    //Wenn SS nicht erreichbar ist, bekommt man HTML durch einen Redirect.
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Common.NotConnected"));
                }
                else if (this.lastCancelToken == currentToken && result.status == this.OK_STATUS) {
                    const searchResult = preserveBookmarks ?? [];
                    result.data.bookmarks = searchResult.concat(result.data.bookmarks);
                    this.setState({ searchResult: result.data, searching: false, searchText: phrasesUris, currentPage: page });
                }
                Helper.setBusyIndicator(false);
            })

        } catch {
            if (this.lastCancelToken == currentToken) {
                //Abfrage wurde abgebrochen
            }
        }
    }

    handleNext = () => {
        const values = this.autoComplete.getSelected();
        this.setState({ searching: true }, () => {
            this.executeSearch(values, values, this.state.currentPage + 1, this.state.searchResult.bookmarks);
        })
    }

    handlePrev = () => {
        const values = this.autoComplete.getSelected();
        this.setState({ searching: true }, () => {
            this.executeSearch(values, values, this.state.currentPage - 1);
        })
    }

    handleFavoriteClick = async (b: Bookmark) => {
        await this.props.onFavoriteClick(b);
        this.forceUpdate();
    }

    handleCollapseAllSheets = () => {
        if (this.props.collapseAllSheets) {
            this.props.collapseAllSheets();
        }
        else {
            const sheetId = this.sheet.id();
            const sheetIndex = General.Sheet.Manager.getSheetIndex(sheetId);
            const sheet = General.Sheet.Manager.getSheetByIndex(sheetIndex == 0 ? 0 : sheetIndex - 1);
            if (sheet) {
                General.Sheet.Manager.forcedRemoveSheetsNoAnimation(sheet.id());
            }

        }
    }

    private renderResult = () => {
        if (!Helper.hasValue(this.state.searchResult)) {
            return null;
        }
        var originalConcepts = this.autoComplete.getSelected();
        const showNoResultsMessage = this.autoComplete.getSelected()?.length > 0 && !this.state.searching;
        return (
            <div style={{}} className="smartSearch">
                <SmartSearchSearchResultPreview
                    id={this.props.id}
                    favoriteIds={this.props.favoriteIds}
                    readOnly={this.props.readOnly}
                    textSearch={this.state.searchText}
                    searchResult={this.state.searchResult}
                    onClickFavorite={this.handleFavoriteClick}
                    showNoResultsMessage={showNoResultsMessage}
                    showMenu={this.props.id != ""}
                    originalConcepts={originalConcepts}
                    hasNext={this.state.searchResult.moreAvailable}
                    onLoadNext={this.handleNext}
                    collapseAllSheets={this.handleCollapseAllSheets}
                >
                </SmartSearchSearchResultPreview >
            </div>
        );

    }

    private renderSearch = () => {
        const search = (
            <div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                <label style={{ marginBottom: "2px" }}>
                    {Helper.getTranslation("SmartSearch.SearchParam")}
                </label>
                <SmartSearchAutoComplete
                    ref={(e) => this.autoComplete = e}
                    initialValues={this.state.initResult}
                    onSelectionChanged={this.handleSelectionChanged}
                />
            </div>
        );

        if (Config.settings.isMobileApp) {
            let mobileSearch = <div className="quick-search-wrapper">
                {search}
            </div>
            return ReactDOM.createPortal(mobileSearch, this.sheet.elements.getToolbarRef()[0]);
        }

        return ReactDOM.createPortal(search, this.leftDrawerRef[0]);
    }

    render() {
        if (!this.state.initialized) {
            return null;
        }
        const sheetIndex = General.Sheet.Manager.getSheetIndex(this.sheet.id());
        return (
            <>
                <Menu entries={[
                    {
                        text: "Alle Sheets schließen",
                        inContext: true,
                        onClick: this.handleCollapseAllSheets,
                        show: sheetIndex > 1,
                        icon: "layer-group"
                    }

                ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} />
                {this.renderSearch()}
                <FullHeightContainer>
                    {this.renderResult()}
                </FullHeightContainer>
            </>
        );
    };
}

export interface SmartSearchListProps {
    id: string;
    initialValue?: string;
    initialConcepts?: { ConceptURI: string, Type: string, Text: string }[];
    initialMachine: string;
    favoriteIds: () => string[];
    removeFavorite: (id: string[]) => Promise<boolean>;
    addFavorite: (b: Bookmark) => Promise<boolean>;
    onFavoriteClick: any;
    readOnly: boolean;
    onLoadNext?: any;
    collapseAllSheets?: () => void;
}

interface SmartSearchListState {
    machineType: string;
    favoriteIds?: () => string[];
    initialized: boolean;
    searchText?: string[];
    smartsearchConfig?: any;
    initialvalues?: any;
    searchResult?: ApiSearchResult;
    initResult?: SmartSearchAPiCompletitionResult[];
    searching: boolean;
    currentPage: number;
}

